// Age Verification Script

(function () {
  "use strict";

  const AGE_VERIFIED_KEY = "ht_age_verified";
  const SESSION_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  function checkAgeVerification() {
    const verified = localStorage.getItem(AGE_VERIFIED_KEY);

    if (!verified) {
      return false;
    }

    try {
      const data = JSON.parse(verified);
      const now = new Date().getTime();

      // Check if verification has expired
      if (now - data.timestamp > SESSION_DURATION) {
        localStorage.removeItem(AGE_VERIFIED_KEY);
        return false;
      }

      return true;
    } catch (e) {
      localStorage.removeItem(AGE_VERIFIED_KEY);
      return false;
    }
  }

  function setAgeVerified() {
    const data = {
      verified: true,
      timestamp: new Date().getTime(),
    };
    localStorage.setItem(AGE_VERIFIED_KEY, JSON.stringify(data));
  }

  function showAgeGate() {
    const ageGate = document.getElementById("ht-age-gate");
    if (ageGate) {
      ageGate.classList.remove("hidden");
      document.body.style.overflow = "hidden";
    }
  }

  function hideAgeGate() {
    const ageGate = document.getElementById("ht-age-gate");
    if (ageGate) {
      ageGate.classList.add("hidden");
      document.body.style.overflow = "";

      // Remove from DOM after transition
      setTimeout(() => {
        ageGate.style.display = "none";
      }, 500);
    }
  }

  function handleYesClick() {
    setAgeVerified();
    hideAgeGate();
  }

  function handleNoClick() {
    const content = document.querySelector(".ht-age-gate-content");
    const verifySection = document.getElementById("ht-age-verify");
    const deniedSection = document.getElementById("ht-age-denied");

    if (content && verifySection && deniedSection) {
      verifySection.style.display = "none";
      deniedSection.classList.add("active");
    }
  }

  function init() {
    // Check if already verified
    if (checkAgeVerification()) {
      hideAgeGate();
      return;
    }

    // Show age gate if not verified
    showAgeGate();

    // Setup event listeners
    const yesBtn = document.getElementById("ht-age-yes");
    const noBtn = document.getElementById("ht-age-no");

    if (yesBtn) {
      yesBtn.addEventListener("click", handleYesClick);
    }

    if (noBtn) {
      noBtn.addEventListener("click", handleNoClick);
    }
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
